function initInput(input) {
  if (!input || !input.form) return

  // Keep validation text outside the control so prefixes and grouped content stay aligned.
  const inputControl = input.closest('.c-form-input--text') || input

  input.form.addEventListener('invalid', _ => inputValidity(input), true)

  function errorState(input, message) {
    input.classList.add('tw-ring', 'tw-ring-red-500')

    // Check if an error message already exists
    let errorMessage = inputControl.parentNode.querySelector('.invalid-input')

    if (!errorMessage) {
      errorMessage = document.createElement('span')
      errorMessage.className = 'invalid-input tw-block tw-text-red-700 tw-font-semibold tw-text-sm tw-mb-2'
      errorMessage.textContent = message
      // Insert the error message before the complete control, not its inner input.
      inputControl.insertAdjacentElement('beforebegin', errorMessage)
    }
  }

  function removeErrorState(input) {
    input.classList.remove('tw-ring', 'tw-ring-red-500')

    // Remove the error message if it exists
    const errorMessage = inputControl.parentNode.querySelector('.invalid-input')
    if (errorMessage) {
      errorMessage.remove()
    }
  }

  function inputValidity(input) {
    if (!input.validity.valid) {
      // if the input is required and has no value
      // We might want to add some type specific validation messages
      if (input.required && !input.value) {
        errorState(input, 'This field is required.')

        input.addEventListener('input', handleInputChange)
      } else {
        errorState(input, 'Invalid input.')
      }
    } else {
      removeErrorState(input)
    }
  }

  function handleInputChange(event) {
    const input = event.target
    if (input.validity.valid) {
      removeErrorState(input)
    }
  }
}

function initializeInputs() {
  const formInputs = document.querySelectorAll('.js-c-form-input--required')
  formInputs.forEach(initInput)
}

initializeInputs()
